import http from "src/shared/http";
import projectOptions from "src/shared/project-options";
import { apiSlice, apiTags } from "src/shared/apiSlice";

const productApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getProductDetail: build.query({
      query: ({ url }) => ({ url }),
      providesTags: (result, error, id) => [apiTags.ProductDetail],
    }),
  }),
});

export const { useGetProductDetailQuery } = productApi;

export function fetchProducts(eventId: string) {
  return http("public/events/" + eventId + "/products/");
}

const sentProductHitEvents: any[] = [];
export function increaseProductHitCount(productId: string | number) {
  if (sentProductHitEvents.includes(productId)) return;
  sentProductHitEvents.push(productId);

  const { eventId, baseUrl } = projectOptions.default.network;
  return http(
    baseUrl + "/public/events/" + eventId + "/hit-count/" + productId + "/",
    {
      method: "POST",
    }
  );
}
